import React, { useEffect, useCallback, useRef } from 'react'
import { change } from 'redux-form'
import PropTypes from 'prop-types'

function CheckboxField (props) {
  const { input, meta, locked, item } = props
  const { label, description , price, icon, cycle,discount} = item
  const { name } = input
  const checkboxEl = useRef(null)
  const initValueFlag = useRef(false)
  const checkLocked = useCallback(() => {
    const { dispatch, form } = meta
    if (locked) {
      dispatch(change(form, name, true))
    }
  }, [meta, name, locked])
  const setInitialValue = useCallback(()=>{
    if(initValueFlag && !initValueFlag.current){
      const { dispatch, form, } = meta
      if (item.initialValue) {
        dispatch(change(form, name, !!item.initialValue))
        initValueFlag.current = true
      }
    }

  },[item.initialValue, name, meta,initValueFlag])
  useEffect(() => {
    checkLocked()
  }, [checkLocked])
  useEffect(() => {
    setInitialValue()
  }, [setInitialValue])
  const renderField = () => {
    if (locked) {
      return (<>
          <input {...input} name={null} type='checkbox' className='of-checkbox__item-checkbox lines-border-1-100' readOnly checked />
          <input {...input} type='hidden' onChange={e => { e.preventDefault() }} readOnly checked />
        </>
      )
    }
    return (<>
        <input {...input} type='checkbox' className='of-checkbox__item-checkbox lines-border-1-100' ref={checkboxEl} checked={input.value} />
      </>
    )
  }
  const getPrice = () => {
    if (price === '0.00') {
      return <span className='of-checkbox__item-free status-font-1-100'>FREE</span>
    }

    if(discount){
      return (
          <div className={'of-checkbox-item-sale'}>
            <div className={'of-checkbox-item-sale__wrapper'}>
              <span className='of-checkbox__item-price status-font-3-100'>${discount.price}</span>
              <span className='of-checkbox__item-cycle status-font-3-100'>{cycle}</span>
            </div>
            <div className={'of-checkbox-item-sale__wrapper'}>
              <div className='of-checkbox-item-sale__terms text-font-4-100'>(${price}{cycle} after the first invoice)</div>
            </div>
          </div>
      )
    }

    return (<>
      <span className='of-checkbox__item-price text-font-1-100'>${price}</span>
      <span className='of-checkbox__item-cycle text-font-1-100'>{cycle}</span>
    </>)
  }



  const onToggle = () => {
    const {form,dispatch} = meta
    dispatch(change(form,name,!input.value))
  }


  const hoverInEffect = () => {
    if(checkboxEl && checkboxEl.current){
      const el  = checkboxEl.current
      if(el.classList.contains('lines-border-1-100')){
        el.classList.remove('lines-border-1-100')
      }
      if(!el.classList.contains('primary-border-1-100')){
        el.classList.add('primary-border-1-100')
      }
    }
  }
  const hoverOutEffect = () => {
    if(checkboxEl && checkboxEl.current){
      const el  = checkboxEl.current
      if(el.classList.contains('primary-border-1-100')){
        el.classList.remove('primary-border-1-100')
      }
      if(!el.classList.contains('lines-border-1-100')){
        el.classList.add('lines-border-1-100')
      }
    }
  }

  return (
      <div className={`of-checkbox__item lines-border-1-100${input.value? ' of-checkbox__item--selected shades-primary-background-1-100':''}`} onClick={onToggle} onMouseEnter={hoverInEffect} onMouseLeave={hoverOutEffect}>
        <div className='of-checkbox__item-left'>
          <div className='of-checkbox__item-container'>
            {renderField()}
            <div className='of-checkbox__item-checkmark primary-background-1-100'>
              <i className='icon-of-tick-solid icon' />
            </div>
          </div>
          {icon ? <div className={`of-checkbox__item-icon primary-background-1-100`}><i className={`icon icon-${icon}`} /></div> : ''}
          <div className='of-checkbox__item-details'>
            {label ? <div className='of-checkbox__item-label text-font-1-100'>{label}</div> : ''}
            {description ? <div className='of-checkbox__item-description text-font-2-100'>{description}</div> : ''}
          </div>
        </div>
        <div className='of-checkbox__item-right'>
          {price ? <div className='of-checkbox__item-price'>{getPrice()}</div> : ''}
        </div>
      </div>
  )
}

CheckboxField.propTypes = {
  input: PropTypes.any,
  readOnly: PropTypes.any,
  checked: PropTypes.any,
  meta: PropTypes.any,
  locked: PropTypes.bool,
  item: PropTypes.any
}

export default CheckboxField
